module.exports = __webpack_public_path__ + "2d11a6c77a496970cc270c388b4f5d8b.svg";